import { theme } from 'theme'
import { css } from 'particles/themes/styled'

const styles = css`
    .MuiPaper-root {
        box-shadow: none;
        padding: 0;
    }
    .MuiDataGrid-footer {
        display: none !important;
    }
    .MuiDataGrid-row {
        &:hover {
            background-color: ${theme.newColors.neutral100} !important;
        }
    }

    .MuiDataGrid-columnHeader {
        padding: 0 16px !important;
    }
    .MuiDataGrid-cell {
        border-right: 1px inset ${theme.newColors.neutral200};
        box-sizing: border-box;
        padding: 0 16px !important;
    }
    .MuiDataGrid-colCellWrapper {
        .MuiDataGrid-cell {
            border-right: none;
            box-sizing: border-box;
        }
    }
`
export default styles
